<template>
  <div class="container">
    <!-- <div class="daily_tab">
      <img @click="handleBack" style="width: 0.32rem; height: 0.59rem" src="../assets/back.png" />
      <div>{{ staffInfo.staffName }}的日报</div>
    </div> -->
    <van-nav-bar :title="staffInfo.staffName + '的日报'" @click-left="handleBack">
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333" />
      </template>
    </van-nav-bar>
    <div class="report_search">
      <div
        style="display:flex;
          align-items: center;
          border:1px solid;
          height: 26px;
          border-color:#dddddd;
          border-radius:4px;
          padding: 4px;"
        @click="showSelectDate"
      >
        <div>{{ currentDate }}</div>
        <i class="iconfont icon-xiangxiajiantou"></i>
      </div>
      <div class="end_date">数据截止时间：{{ currentDateStr }}</div>
    </div>
    <div class="daily_list">
      <div v-for="(item, index) in dailyList" :key="index" style="margin-bottom: 20px">
        <div class="daily_date">
          <div>{{ item.reportDate }}</div>
          <div
            style="width:46px;
              border:1px solid;
              text-align: center;
              line-height: 20px;
              border-color:#ffba19;
              border-radius:11.5px;
              color: #ffba19;
              font-family:Source Han Sans CN;
              font-weight:500;
              color:#ffba19;
              font-size:13px;
              margin-left: 8px;"
              v-if="item.supplementFlag === 0"
          >
            补交
          </div>
        </div>
        <div class="daily_status">{{ item.content }}</div>
        <div v-if="item.reportStatus == '休息'" class="daily_status">{{ item.reportStatus }}</div>
        <div v-if="item.reportStatus == '请假'" class="daily_status">{{ item.reportStatus }}</div>
        <div v-if="item.reportStatus == '未提交'" class="daily_status">{{ item.reportStatus }}</div>
      </div>
    </div>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker
        v-model="selectedDate"
        :type="type == 'day' ? 'date' : 'year-month'"
        :formatter="formatter"
        title="选择年月"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import { getListByStaffIdAndMonth, getListByStaffIdAndDate } from "@/axios/services";
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentDate: "",
      currentDateStr: this.getDate("yyyy-MM-dd", "yesterday"),
      currentMonthStr: this.getCurrentMonth(new Date()),
      type: "",
      staffInfo: {},
      dailyList: [],
      showDatePicker: false,
      selectedDate: "",
    };
  },
  methods: {
    getDate(format = "yyyy-MM-dd", type) {
      let date = null;
      type = type || "today";
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ["yesterday", "today"];
      if (typeDes.includes(type)) {
        date = type === "yesterday" ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === "Invalid Date") {
        return;
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    handleBack() {
      this.$router.back();
    },
    getCurrentMonth(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1);
    },
    getCurrentDay(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1) + "-" + this.checkTime(date.getDate());
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else {
        return `${val}日`;
      }
    },
    dateConfirm() {
      this.showDatePicker = false;
      this.currentDate = this.type === "day" ? dayjs(this.selectedDate).format("YYYY-MM-DD") : dayjs(this.selectedDate).format("YYYY-MM");
      this.getData();
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    showSelectDate() {
      this.showDatePicker = true;
    },
    getData() {
      if (this.staffInfo.type === "day") {
        const params = {
          staffId: this.staffInfo.staffId,
          reportDate: this.currentDate,
        };
        getListByStaffIdAndDate(params).then((res) => {
          if (res.data.code === 0) {
            this.dailyList = res.data.data;
          }
        });
      } else {
        const params = {
          staffId: this.staffInfo.staffId,
          reportMonth: this.currentDate,
        };
        getListByStaffIdAndMonth(params).then((res) => {
          if (res.data.code === 0) {
            this.dailyList = res.data.data;
          }
        });
      }
    },
    getYesterday() {
      let day = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      this.selectedDate = day;
    },
  },
  created() {
    this.type = this.$route.query?.type == "day" ? "day" : "month";
    this.currentDate = this.$route.query?.type == "day" ? this.$route.query?.reportDate : this.$route.query?.reportMonth;
    this.staffInfo = this.$route?.query;
    // this.getYesterday();
    this.selectedDate = this.$route.query?.type == "day" ? new Date(this.$route.query?.reportDate) : new Date(this.$route.query?.reportMonth);
    this.getData();
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  /* padding-top: 1.71rem; */
}
.daily_tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.daily_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.report_search {
  height: 1.2rem;
  margin-top: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
}
.daily_list {
  width: 9rem;
  margin: 12px auto;
  min-height: 5rem;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
}
.daily_date {
  font-family: Source Han Sans CN;
  color: #323233;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
}
.daily_status {
  margin-top: 10px;
  font-family: Source Han Sans CN;
  color: #666666;
  font-size: 12px;
  line-height: 18px;
}
.end_date {
  font-family:Source Han Sans CN;
  color:#999999;
  font-size:12px;
  line-height:12px;
}
</style>
